module.exports = __webpack_public_path__ + "img/gift-icon.d316be10.png";